export enum Processus {
    Adjudication = 'Adjudication',
    Attribution = 'Attribution'
  }